import ConfirmModal from "components/common/modals/confirmModal/ConfirmModal";
import React from "react";

const DiscardPreferenceModal = ({
  confirmCancel,
  onCancel,
  showDiscardModal,
}) => {
  return (
    <>
      <ConfirmModal
        confirmText="Discard"
        title="Discard changes"
        show={showDiscardModal}
        onConfirm={confirmCancel}
        onCancel={onCancel}
        children="All the changes will be lost. Are you sure you want to discard the changes?"
        confirmButtonProps={{
          variant: "contained",
          style: { color: "fff", backgroundColor: "#EF5350" },
        }}
      />
    </>
  );
};

export default DiscardPreferenceModal;
